// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-touch .svg-inline--fa {
  position: relative;
}

:root {
  --gap: 8px;
}

.w-sharing-list:not(:empty) {
  display: inline-flex;
  flex-wrap: wrap;
}

.w-sharing-item {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  padding: 0 0.8em;
  min-width: 3em;
  border-color: var(--color-content-border);
  text-align: center;
  line-height: 2;
  transition: none;
}

.w-sharing a.w-sharing-item, .no-touch a.w-sharing-item:hover {
  color: inherit;
}

.w-sharing-item i {
  position: relative;
  min-width: 1em;
  line-height: inherit;
}

.w-sharing.align_center {
  justify-content: center;
}

.w-sharing.align_right {
  justify-content: flex-end;
}

.w-sharing.align_justify .w-sharing-list {
  display: flex;
}

.w-sharing.align_justify .w-sharing-item {
  flex: 1 0 40px;
}

.w-sharing.type_simple .w-sharing-item {
  margin: 0.1em 0;
  border-width: 0 1px 0 0;
  border-style: solid;
}

.w-sharing.type_simple .w-sharing-item:last-child {
  border: none;
}

.w-sharing.type_simple .w-sharing-item i {
  opacity: 0.5;
}

.no-touch .w-sharing.type_simple .w-sharing-item:hover i {
  opacity: 1;
}

.w-sharing.type_solid .w-sharing-list, .w-sharing.type_outlined .w-sharing-list {
  margin: 0 -0.1em;
}

.w-sharing.type_solid .w-sharing-item, .w-sharing.type_outlined .w-sharing-item {
  margin: 0.1em;
  border-radius: 0.3em;
}

.w-sharing.type_outlined .w-sharing-item {
  box-shadow: inset 0 0 0 2px;
}

.w-sharing.type_solid .w-sharing-item, .no-touch .w-sharing.type_outlined .w-sharing-item:hover {
  box-shadow: none;
  color: #fff !important;
}

.w-sharing.type_fixed {
  position: fixed;
  z-index: 97;
}

.w-sharing.type_fixed.align_none, .w-sharing.type_fixed.align_left {
  top: 50%;
  left: 0;
  transform: translate3d(0, -50%, 0);
}

.w-sharing.type_fixed.align_right {
  top: 50%;
  right: 0;
  transform: translate3d(0, -50%, 0);
}

.w-sharing.type_fixed.align_none .w-sharing-list, .w-sharing.type_fixed.align_left .w-sharing-list, .w-sharing.type_fixed.align_right .w-sharing-list {
  display: block;
}

.w-sharing.type_fixed.align_center {
  bottom: 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
}

.w-sharing.type_fixed .w-sharing-item {
  display: block;
  padding: 0;
  min-width: 0;
  width: 2.2em;
  color: #fff !important;
  line-height: 2.2;
}

.w-sharing.type_fixed.align_justify {
  right: 0;
  bottom: 0;
  left: 0;
}

.w-sharing.type_solid .w-sharing-item.email, .w-sharing.type_fixed .w-sharing-item.email, .no-touch .w-sharing.type_outlined .w-sharing-item.email:hover {
  background: #96a2a8;
}

.w-sharing.type_outlined .w-sharing-item.email, .no-touch .w-sharing.type_simple .w-sharing-item.email:hover i {
  color: #96a2a8;
}

.w-sharing.type_solid .w-sharing-item.facebook, .w-sharing.type_fixed .w-sharing-item.facebook, .no-touch .w-sharing.type_outlined .w-sharing-item.facebook:hover {
  background: #1e77f0;
}

.w-sharing.type_outlined .w-sharing-item.facebook, .no-touch .w-sharing.type_simple .w-sharing-item.facebook:hover i {
  color: #1e77f0;
}

.w-sharing.type_solid .w-sharing-item.twitter, .w-sharing.type_fixed .w-sharing-item.twitter, .no-touch .w-sharing.type_outlined .w-sharing-item.twitter:hover {
  background: #55acee;
}

.w-sharing.type_outlined .w-sharing-item.twitter, .no-touch .w-sharing.type_simple .w-sharing-item.twitter:hover i {
  color: #55acee;
}

.w-sharing.type_solid .w-sharing-item.linkedin, .w-sharing.type_fixed .w-sharing-item.linkedin, .no-touch .w-sharing.type_outlined .w-sharing-item.linkedin:hover {
  background: #0077b5;
}

.w-sharing.type_outlined .w-sharing-item.linkedin, .no-touch .w-sharing.type_simple .w-sharing-item.linkedin:hover i {
  color: #0077b5;
}

.w-sharing.type_solid .w-sharing-item.pinterest, .w-sharing.type_fixed .w-sharing-item.pinterest, .no-touch .w-sharing.type_outlined .w-sharing-item.pinterest:hover {
  background: #e60023;
}

.w-sharing.type_outlined .w-sharing-item.pinterest, .no-touch .w-sharing.type_simple .w-sharing-item.pinterest:hover i {
  color: #e60023;
}

.w-sharing.type_solid .w-sharing-item.vk, .w-sharing.type_fixed .w-sharing-item.vk, .no-touch .w-sharing.type_outlined .w-sharing-item.vk:hover {
  background: #2787F5;
}

.w-sharing.type_outlined .w-sharing-item.vk, .no-touch .w-sharing.type_simple .w-sharing-item.vk:hover i {
  color: #2787F5;
}

.w-sharing.type_solid .w-sharing-item.whatsapp, .w-sharing.type_fixed .w-sharing-item.whatsapp, .no-touch .w-sharing.type_outlined .w-sharing-item.whatsapp:hover {
  background: #25d366;
}

.w-sharing.type_outlined .w-sharing-item.whatsapp, .no-touch .w-sharing.type_simple .w-sharing-item.whatsapp:hover i {
  color: #25d366;
}

.w-sharing.type_solid .w-sharing-item.xing, .w-sharing.type_fixed .w-sharing-item.xing, .no-touch .w-sharing.type_outlined .w-sharing-item.xing:hover {
  background: #006464;
}

.w-sharing.type_outlined .w-sharing-item.xing, .no-touch .w-sharing.type_simple .w-sharing-item.xing:hover i {
  color: #006464;
}

.w-sharing.type_solid .w-sharing-item.reddit, .w-sharing.type_fixed .w-sharing-item.reddit, .no-touch .w-sharing.type_outlined .w-sharing-item.reddit:hover {
  background: #ff4500;
}

.w-sharing.type_outlined .w-sharing-item.reddit, .no-touch .w-sharing.type_simple .w-sharing-item.reddit:hover i {
  color: #ff4500;
}

.w-sharing.type_solid .w-sharing-item.telegram, .w-sharing.type_fixed .w-sharing-item.telegram, .no-touch .w-sharing.type_outlined .w-sharing-item.telegram:hover {
  background: #0e8ed4;
}

.w-sharing.type_outlined .w-sharing-item.telegram, .no-touch .w-sharing.type_simple .w-sharing-item.telegram:hover i {
  color: #0e8ed4;
}

.w-sharing-tooltip {
  position: absolute;
  z-index: 999;
  overflow: hidden;
  margin-bottom: 1rem;
}

.w-sharing-tooltip .w-sharing-item {
  padding: 0;
  min-width: 2.2em;
  background: #222;
  color: #fff !important;
  font-size: 1rem;
  line-height: 2.2;
  transition: none;
}

.color_alternate .w-sharing-item {
  border-color: var(--color-alt-content-border);
}

.color_footer-top .w-sharing-item {
  border-color: var(--color-subfooter-border);
}

.color_footer-bottom .w-sharing-item {
  border-color: var(--color-footer-border);
}

.w-sharing.type_outlined.color_primary .w-sharing-item, .no-touch .w-sharing.type_simple.color_primary .w-sharing-item:hover i {
  color: var(--color-content-primary);
}

.w-sharing.type_solid.color_primary .w-sharing-item, .w-sharing.type_fixed.color_primary .w-sharing-item, .no-touch .w-sharing-tooltip .w-sharing-item:hover {
  background: var(--color-content-primary-grad);
}

.w-sharing.type_outlined.color_secondary .w-sharing-item, .no-touch .w-sharing.type_simple.color_secondary .w-sharing-item:hover i {
  color: var(--color-content-secondary);
}

.w-sharing.type_solid.color_secondary .w-sharing-item, .w-sharing.type_fixed.color_secondary .w-sharing-item {
  background: var(--color-content-secondary-grad);
}

.rounded_none .w-sharing-item {
  border-radius: 0 !important;
}

.w-socials-list {
  margin: calc(var(--gap, 0) * -1);
}

.w-socials-item {
  position: relative;
  display: inline-block;
  padding: var(--gap, 0);
  vertical-align: top;
}

.w-socials-item-link {
  position: relative;
  z-index: 0;
  display: block;
  overflow: hidden;
  width: 2.5em;
  border: none !important;
  border-radius: inherit;
  text-align: center;
  line-height: 2.5em;
}

.w-socials.color_text .w-socials-item-link {
  color: inherit;
}

.w-socials-item-link-hover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  background: var(--color-content-primary-grad);
}

.w-socials-item-link i {
  position: relative;
  display: block;
  line-height: inherit;
}

.w-socials-item-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  z-index: 90;
  display: none;
  visibility: hidden;
  margin-bottom: 7px;
  padding: 0 1rem;
  border-radius: 0.25rem;
  background: #222;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  font-size: 20px;
  line-height: 53px;
  opacity: 0;
  transition: opacity 0.2s cubic-bezier(0.78, 0.13, 0.15, 0.86) 0.3s, transform 0.2s cubic-bezier(0.78, 0.13, 0.15, 0.86) 0.3s;
  transform: translate3d(-50%, -1em, 0);
}

.w-socials-item-link:focus + .w-socials-item-popup, .w-socials-item-link:hover + .w-socials-item-popup {
  visibility: visible;
  opacity: 1;
  transform: translate3d(-50%, 0, 0);
}

.no-touch .w-socials-item-popup {
  display: block;
}

.w-socials-item-popup:after {
  position: absolute;
  bottom: -7px;
  left: 50%;
  display: block;
  margin-left: -8px;
  width: 0;
  height: 0;
  border-top: 8px solid #333;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  content: "";
}

.l-header .w-socials {
  line-height: 2;
}

.header_hor .l-header .w-socials-list {
  white-space: nowrap;
}

.l-header .w-socials-item-link {
  width: 2em;
  line-height: 2em;
}

.w-socials.stretch .w-socials-list {
  display: flex;
  flex-wrap: wrap;
}

.w-socials.stretch .w-socials-item {
  flex: 1 0 40px;
}

.w-socials.stretch .w-socials-item-link {
  min-width: 1.5em;
  width: auto;
}

.w-socials.shape_none .w-socials-item-link {
  width: auto;
  line-height: 1;
}

.w-socials.shape_rounded .w-socials-item-link {
  border-radius: 0.25em;
}

.w-socials.shape_circle .w-socials-item-link {
  border-radius: 50%;
}

.no-touch .w-socials.hover_slide .w-socials-item-link-hover {
  bottom: auto;
  display: block;
  height: 0;
  transition: height 0.3s;
}

.no-touch .w-socials.hover_slide .w-socials-item-link:hover .w-socials-item-link-hover {
  height: 100%;
}

.no-touch .w-socials.hover_fade .w-socials-item-link-hover {
  display: block;
  opacity: 0;
  transition: opacity 0.3s;
}

.no-touch .w-socials.hover_fade .w-socials-item-link:hover .w-socials-item-link-hover {
  opacity: 1;
}

.no-touch .w-socials.hover_fade .w-socials-item-link:hover, .no-touch .w-socials.hover_slide .w-socials-item-link:hover {
  color: #fff !important;
}

.w-socials.style_solid .w-socials-item-link {
  background: var(--color-content-bg-alt-grad);
}

.w-socials.style_colored .w-socials-item-link-hover {
  display: block;
  height: 100% !important;
  opacity: 1 !important;
}

.w-socials.style_colored .w-socials-item-link {
  color: #fff !important;
}

.w-socials.style_outlined .w-socials-item-link {
  box-shadow: inset 0 0 0 2px var(--color-content-border);
}

.w-socials.color_brand .w-socials-item.s500px .w-socials-item-link {
  color: inherit;
}

.w-socials-item.s500px .w-socials-item-link-hover {
  background: #222;
}

.w-socials.color_brand .w-socials-item.behance .w-socials-item-link {
  color: #1769ff;
}

.w-socials-item.behance .w-socials-item-link-hover {
  background: #1769ff;
}

.w-socials.color_brand .w-socials-item.deviantart .w-socials-item-link {
  color: #00e59b !important;
}

.w-socials-item.deviantart .w-socials-item-link-hover {
  background: #0e0d20;
}

.w-socials.color_brand .w-socials-item.discord .w-socials-item-link {
  color: #5865F2;
}

.w-socials-item.discord .w-socials-item-link-hover {
  background: #5865F2;
}

.w-socials.color_brand .w-socials-item.dribbble .w-socials-item-link {
  color: #ea4c89;
}

.w-socials-item.dribbble .w-socials-item-link-hover {
  background: #ea4c89;
}

.w-socials.color_brand .w-socials-item.email .w-socials-item-link {
  color: #96a2a8;
}

.w-socials-item.email .w-socials-item-link-hover {
  background: #96a2a8;
}

.w-socials.color_brand .w-socials-item.facebook .w-socials-item-link {
  color: #1e77f0;
}

.w-socials-item.facebook .w-socials-item-link-hover {
  background: #1e77f0;
}

.w-socials.color_brand .w-socials-item.flickr .w-socials-item-link {
  color: #ff0084;
}

.w-socials-item.flickr .w-socials-item-link-hover {
  background: #ff0084;
}

.w-socials.color_brand .w-socials-item.foursquare .w-socials-item-link {
  color: #fa4b7a;
}

.w-socials-item.foursquare .w-socials-item-link-hover {
  background: #fa4b7a;
}

.w-socials.color_brand .w-socials-item.github .w-socials-item-link {
  color: inherit;
}

.w-socials-item.github .w-socials-item-link-hover {
  background: #24292e;
}

.w-socials.color_brand .w-socials-item.google .w-socials-item-link {
  color: #ff3e30;
}

.w-socials-item.google .w-socials-item-link-hover {
  background: #ff3e30;
}

.w-socials.color_brand .w-socials-item.houzz .w-socials-item-link {
  color: #4dbc15;
}

.w-socials-item.houzz .w-socials-item-link-hover {
  background: #4dbc15;
}

.w-socials.color_brand .w-socials-item.imdb .w-socials-item-link {
  color: #f7c625;
}

.w-socials-item.imdb .w-socials-item-link-hover {
  background: #f7c625;
}

.w-socials.color_brand .w-socials-item.instagram .w-socials-item-link {
  color: inherit;
}

.w-socials-item.instagram .w-socials-item-link-hover {
  background: #a17357;
  background: radial-gradient(circle farthest-corner at 35% 100%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 10% 140%, #feda7e, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e42e66 50%, #fa5332 70%, #ffdc80 100%);
}

.w-socials-item.instagram .w-socials-item-link i {
  font-size: 1.1em;
}

.w-socials.color_brand .w-socials-item.linkedin .w-socials-item-link {
  color: #0077b5;
}

.w-socials-item.linkedin .w-socials-item-link-hover {
  background: #0077b5;
}

.w-socials.color_brand .w-socials-item.medium .w-socials-item-link {
  color: inherit;
}

.w-socials-item.medium .w-socials-item-link-hover {
  background: #1c1b1a;
}

.w-socials.color_brand .w-socials-item.odnoklassniki .w-socials-item-link {
  color: #f58220;
}

.w-socials-item.odnoklassniki .w-socials-item-link-hover {
  background: #f58220;
}

.w-socials.color_brand .w-socials-item.pinterest .w-socials-item-link {
  color: #e60023;
}

.w-socials-item.pinterest .w-socials-item-link-hover {
  background: #e60023;
}

.w-socials.color_brand .w-socials-item.reddit .w-socials-item-link {
  color: #ff4500;
}

.w-socials-item.reddit .w-socials-item-link-hover {
  background: #ff4500;
}

.w-socials.color_brand .w-socials-item.rss .w-socials-item-link {
  color: #ff9702;
}

.w-socials-item.rss .w-socials-item-link-hover {
  background: #ff9702;
}

.w-socials.color_brand .w-socials-item.skype .w-socials-item-link {
  color: #00aff0;
}

.w-socials-item.skype .w-socials-item-link-hover {
  background: #00aff0;
}

.w-socials.color_brand .w-socials-item.soundcloud .w-socials-item-link {
  color: #ff5600;
}

.w-socials-item.soundcloud .w-socials-item-link-hover {
  background: #ff5600;
}

.w-socials.color_brand .w-socials-item.telegram .w-socials-item-link {
  color: #0e8ed4;
}

.w-socials-item.telegram .w-socials-item-link-hover {
  background: #0e8ed4;
}

.w-socials.color_brand .tiktok .w-socials-item-link {
  color: inherit;
  text-shadow: 0.04em 0.04em 0 #ee1d52, -0.04em -0.04em 0 #69c9d0;
}

.w-socials .tiktok .w-socials-item-link-hover {
  background: #000;
}

.w-socials.color_brand .tripadvisor .w-socials-item-link {
  color: inherit;
}

.w-socials.style_colored .tripadvisor .w-socials-item-link, .no-touch .w-socials:not(.shape_none):not(.hover_none) .tripadvisor .w-socials-item-link:hover {
  color: #000a12 !important;
}

.w-socials .tripadvisor .w-socials-item-link-hover {
  background: #34e0a1;
}

.w-socials.color_brand .w-socials-item.tumblr .w-socials-item-link {
  color: #37465d;
}

.w-socials-item.tumblr .w-socials-item-link-hover {
  background: #37465d;
}

.w-socials.color_brand .w-socials-item.twitch .w-socials-item-link {
  color: #6441a5;
}

.w-socials-item.twitch .w-socials-item-link-hover {
  background: #6441a5;
}

.w-socials.color_brand .w-socials-item.twitter .w-socials-item-link {
  color: #55acee;
}

.w-socials-item.twitter .w-socials-item-link-hover {
  background: #55acee;
}

.w-socials.color_brand .w-socials-item.vimeo .w-socials-item-link {
  color: #1ab7ea;
}

.w-socials-item.vimeo .w-socials-item-link-hover {
  background: #1ab7ea;
}

.w-socials.color_brand .w-socials-item.vk .w-socials-item-link {
  color: #2787F5;
}

.w-socials-item.vk .w-socials-item-link-hover {
  background: #2787F5;
}

.w-socials.color_brand .w-socials-item.wechat .w-socials-item-link {
  color: #60c33a;
}

.w-socials-item.wechat .w-socials-item-link-hover {
  background: #60c33a;
}

.w-socials.color_brand .w-socials-item.whatsapp .w-socials-item-link {
  color: #25d366;
}

.w-socials-item.whatsapp .w-socials-item-link-hover {
  background: #25d366;
}

.w-socials.color_brand .w-socials-item.xing .w-socials-item-link {
  color: #006464;
}

.w-socials-item.xing .w-socials-item-link-hover {
  background: #006464;
}

.w-socials.color_brand .w-socials-item.yelp .w-socials-item-link {
  color: #d32323;
}

.w-socials-item.yelp .w-socials-item-link-hover {
  background: #d32323;
}

.w-socials.color_brand .w-socials-item.youtube .w-socials-item-link {
  color: #f00;
}

.w-socials-item.youtube .w-socials-item-link-hover {
  background: #f00;
}

.color_alternate .w-socials.style_solid .w-socials-item-link {
  background: var(--color-alt-content-bg-alt-grad);
}

.color_alternate .w-socials.style_outlined .w-socials-item-link {
  box-shadow: inset 0 0 0 2px var(--color-alt-content-border);
}

.color_footer-top .w-socials.style_solid .w-socials-item-link {
  background: var(--color-subfooter-bg-alt-grad);
}

.color_footer-top .w-socials.style_outlined .w-socials-item-link {
  box-shadow: inset 0 0 0 2px var(--color-subfooter-border);
}

.color_footer-bottom .w-socials.style_solid .w-socials-item-link {
  background: var(--color-footer-bg-alt-grad);
}

.color_footer-bottom .w-socials.style_outlined .w-socials-item-link {
  box-shadow: inset 0 0 0 2px var(--color-footer-border);
}

.rounded_none .w-socials-item-popup {
  border-radius: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/common/SocialLinks.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,oBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,oBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,oBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,eAAA;EACA,WAAA;AACJ;;AAEA;EACI,QAAA;EACA,OAAA;EACA,kCAAA;AACJ;;AAEA;EACI,QAAA;EACA,QAAA;EACA,kCAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,SAAA;EACA,kCAAA;AACJ;;AAEA;EACI,cAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,QAAA;EACA,SAAA;EACA,OAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,6CAAA;AACJ;;AAEA;EACI,2CAAA;AACJ;;AAEA;EACI,wCAAA;AACJ;;AAEA;EACI,mCAAA;AACJ;;AAEA;EACI,6CAAA;AACJ;;AAEA;EACI,qCAAA;AACJ;;AAEA;EACI,+CAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,6CAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,oBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EAEA,eAAA;EAEA,iBAAA;EACA,UAAA;EACA,4HAAA;EACA,qCAAA;AADJ;;AAIA;EACI,mBAAA;EACA,UAAA;EACA,kCAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;EACA,WAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,UAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,eAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,gBAAA;EACA,WAAA;AADJ;;AAIA;EACI,WAAA;EACA,cAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,YAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,cAAA;EACA,UAAA;EACA,wBAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,sBAAA;AADJ;;AAIA;EACI,4CAAA;AADJ;;AAIA;EACI,cAAA;EACA,uBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,sBAAA;AADJ;;AAIA;EACI,uDAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;EACA,goBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;EACA,+DAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gDAAA;AADJ;;AAIA;EACI,2DAAA;AADJ;;AAIA;EACI,8CAAA;AADJ;;AAIA;EACI,yDAAA;AADJ;;AAIA;EACI,2CAAA;AADJ;;AAIA;EACI,sDAAA;AADJ;;AAIA;EACI,2BAAA;AADJ","sourcesContent":[".no-touch .svg-inline--fa {\n    position: relative;\n}\n\n:root {\n    --gap: 8px;\n}\n\n.w-sharing-list:not(:empty) {\n    display: inline-flex;\n    flex-wrap: wrap\n}\n\n.w-sharing-item {\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    justify-content: center;\n    padding: 0 0.8em;\n    min-width: 3em;\n    border-color: var(--color-content-border);\n    text-align: center;\n    line-height: 2;\n    transition: none;\n}\n\n.w-sharing a.w-sharing-item,.no-touch a.w-sharing-item:hover {\n    color: inherit\n}\n\n.w-sharing-item i {\n    position: relative;\n    min-width: 1em;\n    line-height: inherit\n}\n\n.w-sharing.align_center {\n    justify-content: center\n}\n\n.w-sharing.align_right {\n    justify-content: flex-end\n}\n\n.w-sharing.align_justify .w-sharing-list {\n    display: flex\n}\n\n.w-sharing.align_justify .w-sharing-item {\n    flex: 1 0 40px\n}\n\n.w-sharing.type_simple .w-sharing-item {\n    margin: 0.1em 0;\n    border-width: 0 1px 0 0;\n    border-style: solid\n}\n\n.w-sharing.type_simple .w-sharing-item:last-child {\n    border: none\n}\n\n.w-sharing.type_simple .w-sharing-item i {\n    opacity: 0.5\n}\n\n.no-touch .w-sharing.type_simple .w-sharing-item:hover i {\n    opacity: 1\n}\n\n.w-sharing.type_solid .w-sharing-list,.w-sharing.type_outlined .w-sharing-list {\n    margin: 0 -0.1em\n}\n\n.w-sharing.type_solid .w-sharing-item,.w-sharing.type_outlined .w-sharing-item {\n    margin: 0.1em;\n    border-radius: 0.3em\n}\n\n.w-sharing.type_outlined .w-sharing-item {\n    box-shadow: inset 0 0 0 2px\n}\n\n.w-sharing.type_solid .w-sharing-item,.no-touch .w-sharing.type_outlined .w-sharing-item:hover {\n    box-shadow: none;\n    color: #fff!important\n}\n\n.w-sharing.type_fixed {\n    position: fixed;\n    z-index: 97\n}\n\n.w-sharing.type_fixed.align_none,.w-sharing.type_fixed.align_left {\n    top: 50%;\n    left: 0;\n    transform: translate3d(0,-50%,0)\n}\n\n.w-sharing.type_fixed.align_right {\n    top: 50%;\n    right: 0;\n    transform: translate3d(0,-50%,0)\n}\n\n.w-sharing.type_fixed.align_none .w-sharing-list,.w-sharing.type_fixed.align_left .w-sharing-list,.w-sharing.type_fixed.align_right .w-sharing-list {\n    display: block\n}\n\n.w-sharing.type_fixed.align_center {\n    bottom: 0;\n    left: 50%;\n    transform: translate3d(-50%,0,0)\n}\n\n.w-sharing.type_fixed .w-sharing-item {\n    display: block;\n    padding: 0;\n    min-width: 0;\n    width: 2.2em;\n    color: #fff!important;\n    line-height: 2.2;\n}\n\n.w-sharing.type_fixed.align_justify {\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.w-sharing.type_solid .w-sharing-item.email,.w-sharing.type_fixed .w-sharing-item.email,.no-touch .w-sharing.type_outlined .w-sharing-item.email:hover {\n    background: #96a2a8\n}\n\n.w-sharing.type_outlined .w-sharing-item.email,.no-touch .w-sharing.type_simple .w-sharing-item.email:hover i {\n    color: #96a2a8\n}\n\n.w-sharing.type_solid .w-sharing-item.facebook,.w-sharing.type_fixed .w-sharing-item.facebook,.no-touch .w-sharing.type_outlined .w-sharing-item.facebook:hover {\n    background: #1e77f0\n}\n\n.w-sharing.type_outlined .w-sharing-item.facebook,.no-touch .w-sharing.type_simple .w-sharing-item.facebook:hover i {\n    color: #1e77f0\n}\n\n.w-sharing.type_solid .w-sharing-item.twitter,.w-sharing.type_fixed .w-sharing-item.twitter,.no-touch .w-sharing.type_outlined .w-sharing-item.twitter:hover {\n    background: #55acee\n}\n\n.w-sharing.type_outlined .w-sharing-item.twitter,.no-touch .w-sharing.type_simple .w-sharing-item.twitter:hover i {\n    color: #55acee\n}\n\n.w-sharing.type_solid .w-sharing-item.linkedin,.w-sharing.type_fixed .w-sharing-item.linkedin,.no-touch .w-sharing.type_outlined .w-sharing-item.linkedin:hover {\n    background: #0077b5\n}\n\n.w-sharing.type_outlined .w-sharing-item.linkedin,.no-touch .w-sharing.type_simple .w-sharing-item.linkedin:hover i {\n    color: #0077b5\n}\n\n.w-sharing.type_solid .w-sharing-item.pinterest,.w-sharing.type_fixed .w-sharing-item.pinterest,.no-touch .w-sharing.type_outlined .w-sharing-item.pinterest:hover {\n    background: #e60023\n}\n\n.w-sharing.type_outlined .w-sharing-item.pinterest,.no-touch .w-sharing.type_simple .w-sharing-item.pinterest:hover i {\n    color: #e60023\n}\n\n.w-sharing.type_solid .w-sharing-item.vk,.w-sharing.type_fixed .w-sharing-item.vk,.no-touch .w-sharing.type_outlined .w-sharing-item.vk:hover {\n    background: #2787F5\n}\n\n.w-sharing.type_outlined .w-sharing-item.vk,.no-touch .w-sharing.type_simple .w-sharing-item.vk:hover i {\n    color: #2787F5\n}\n\n.w-sharing.type_solid .w-sharing-item.whatsapp,.w-sharing.type_fixed .w-sharing-item.whatsapp,.no-touch .w-sharing.type_outlined .w-sharing-item.whatsapp:hover {\n    background: #25d366\n}\n\n.w-sharing.type_outlined .w-sharing-item.whatsapp,.no-touch .w-sharing.type_simple .w-sharing-item.whatsapp:hover i {\n    color: #25d366\n}\n\n.w-sharing.type_solid .w-sharing-item.xing,.w-sharing.type_fixed .w-sharing-item.xing,.no-touch .w-sharing.type_outlined .w-sharing-item.xing:hover {\n    background: #006464\n}\n\n.w-sharing.type_outlined .w-sharing-item.xing,.no-touch .w-sharing.type_simple .w-sharing-item.xing:hover i {\n    color: #006464\n}\n\n.w-sharing.type_solid .w-sharing-item.reddit,.w-sharing.type_fixed .w-sharing-item.reddit,.no-touch .w-sharing.type_outlined .w-sharing-item.reddit:hover {\n    background: #ff4500\n}\n\n.w-sharing.type_outlined .w-sharing-item.reddit,.no-touch .w-sharing.type_simple .w-sharing-item.reddit:hover i {\n    color: #ff4500\n}\n\n.w-sharing.type_solid .w-sharing-item.telegram,.w-sharing.type_fixed .w-sharing-item.telegram,.no-touch .w-sharing.type_outlined .w-sharing-item.telegram:hover {\n    background: #0e8ed4\n}\n\n.w-sharing.type_outlined .w-sharing-item.telegram,.no-touch .w-sharing.type_simple .w-sharing-item.telegram:hover i {\n    color: #0e8ed4\n}\n\n.w-sharing-tooltip {\n    position: absolute;\n    z-index: 999;\n    overflow: hidden;\n    margin-bottom: 1rem\n}\n\n.w-sharing-tooltip .w-sharing-item {\n    padding: 0;\n    min-width: 2.2em;\n    background: #222;\n    color: #fff!important;\n    font-size: 1rem;\n    line-height: 2.2;\n    transition: none;\n}\n\n.color_alternate .w-sharing-item {\n    border-color: var(--color-alt-content-border)\n}\n\n.color_footer-top .w-sharing-item {\n    border-color: var(--color-subfooter-border)\n}\n\n.color_footer-bottom .w-sharing-item {\n    border-color: var(--color-footer-border)\n}\n\n.w-sharing.type_outlined.color_primary .w-sharing-item,.no-touch .w-sharing.type_simple.color_primary .w-sharing-item:hover i {\n    color: var(--color-content-primary)\n}\n\n.w-sharing.type_solid.color_primary .w-sharing-item,.w-sharing.type_fixed.color_primary .w-sharing-item,.no-touch .w-sharing-tooltip .w-sharing-item:hover {\n    background: var(--color-content-primary-grad)\n}\n\n.w-sharing.type_outlined.color_secondary .w-sharing-item,.no-touch .w-sharing.type_simple.color_secondary .w-sharing-item:hover i {\n    color: var(--color-content-secondary)\n}\n\n.w-sharing.type_solid.color_secondary .w-sharing-item,.w-sharing.type_fixed.color_secondary .w-sharing-item {\n    background: var(--color-content-secondary-grad)\n}\n\n.rounded_none .w-sharing-item {\n    border-radius: 0!important\n}\n\n.w-socials-list {\n    margin: calc( var(--gap,0) * -1 )\n}\n\n.w-socials-item {\n    position: relative;\n    display: inline-block;\n    padding: var(--gap,0);\n    vertical-align: top;\n}\n\n.w-socials-item-link {\n    position: relative;\n    z-index: 0;\n    display: block;\n    overflow: hidden;\n    width: 2.5em;\n    border: none!important;\n    border-radius: inherit;\n    text-align: center;\n    line-height: 2.5em;\n}\n\n.w-socials.color_text .w-socials-item-link {\n    color: inherit\n}\n\n.w-socials-item-link-hover {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: none;\n    background: var(--color-content-primary-grad)\n}\n\n.w-socials-item-link i {\n    position: relative;\n    display: block;\n    line-height: inherit;\n}\n\n.w-socials-item-popup {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    z-index: 90;\n    display: none;\n    visibility: hidden;\n    margin-bottom: 7px;\n    padding: 0 1rem;\n    border-radius: 0.25rem;\n    background: #222;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    // font-size: 0.9rem;\n    font-size: 20px;\n    // line-height: 2.4rem;\n    line-height: 53px;\n    opacity: 0;\n    transition: opacity 0.2s cubic-bezier(.78,.13,.15,.86) 0.3s,transform 0.2s cubic-bezier(.78,.13,.15,.86) 0.3s;\n    transform: translate3d(-50%,-1em,0);\n}\n\n.w-socials-item-link:focus + .w-socials-item-popup,.w-socials-item-link:hover + .w-socials-item-popup {\n    visibility: visible;\n    opacity: 1;\n    transform: translate3d(-50%,0,0)\n}\n\n.no-touch .w-socials-item-popup {\n    display: block\n}\n\n.w-socials-item-popup:after {\n    position: absolute;\n    bottom: -7px;\n    left: 50%;\n    display: block;\n    margin-left: -8px;\n    width: 0;\n    height: 0;\n    border-top: 8px solid #333;\n    border-right: 8px solid transparent;\n    border-left: 8px solid transparent;\n    content: '';\n}\n\n.l-header .w-socials {\n    line-height: 2\n}\n\n.header_hor .l-header .w-socials-list {\n    white-space: nowrap\n}\n\n.l-header .w-socials-item-link {\n    width: 2em;\n    line-height: 2em;\n}\n\n.w-socials.stretch .w-socials-list {\n    display: flex;\n    flex-wrap: wrap\n}\n\n.w-socials.stretch .w-socials-item {\n    flex: 1 0 40px\n}\n\n.w-socials.stretch .w-socials-item-link {\n    min-width: 1.5em;\n    width: auto;\n}\n\n.w-socials.shape_none .w-socials-item-link {\n    width: auto;\n    line-height: 1;\n}\n\n.w-socials.shape_rounded .w-socials-item-link {\n    border-radius: 0.25em\n}\n\n.w-socials.shape_circle .w-socials-item-link {\n    border-radius: 50%\n}\n\n.no-touch .w-socials.hover_slide .w-socials-item-link-hover {\n    bottom: auto;\n    display: block;\n    height: 0;\n    transition: height 0.3s\n}\n\n.no-touch .w-socials.hover_slide .w-socials-item-link:hover .w-socials-item-link-hover {\n    height: 100%\n}\n\n.no-touch .w-socials.hover_fade .w-socials-item-link-hover {\n    display: block;\n    opacity: 0;\n    transition: opacity 0.3s\n}\n\n.no-touch .w-socials.hover_fade .w-socials-item-link:hover .w-socials-item-link-hover {\n    opacity: 1\n}\n\n.no-touch .w-socials.hover_fade .w-socials-item-link:hover,.no-touch .w-socials.hover_slide .w-socials-item-link:hover {\n    color: #fff!important\n}\n\n.w-socials.style_solid .w-socials-item-link {\n    background: var(--color-content-bg-alt-grad)\n}\n\n.w-socials.style_colored .w-socials-item-link-hover {\n    display: block;\n    height: 100%!important;\n    opacity: 1!important\n}\n\n.w-socials.style_colored .w-socials-item-link {\n    color: #fff!important\n}\n\n.w-socials.style_outlined .w-socials-item-link {\n    box-shadow: inset 0 0 0 2px var(--color-content-border)\n}\n\n.w-socials.color_brand .w-socials-item.s500px .w-socials-item-link {\n    color: inherit\n}\n\n.w-socials-item.s500px .w-socials-item-link-hover {\n    background: #222\n}\n\n.w-socials.color_brand .w-socials-item.behance .w-socials-item-link {\n    color: #1769ff\n}\n\n.w-socials-item.behance .w-socials-item-link-hover {\n    background: #1769ff\n}\n\n.w-socials.color_brand .w-socials-item.deviantart .w-socials-item-link {\n    color: #00e59b!important\n}\n\n.w-socials-item.deviantart .w-socials-item-link-hover {\n    background: #0e0d20\n}\n\n.w-socials.color_brand .w-socials-item.discord .w-socials-item-link {\n    color: #5865F2\n}\n\n.w-socials-item.discord .w-socials-item-link-hover {\n    background: #5865F2\n}\n\n.w-socials.color_brand .w-socials-item.dribbble .w-socials-item-link {\n    color: #ea4c89\n}\n\n.w-socials-item.dribbble .w-socials-item-link-hover {\n    background: #ea4c89\n}\n\n.w-socials.color_brand .w-socials-item.email .w-socials-item-link {\n    color: #96a2a8\n}\n\n.w-socials-item.email .w-socials-item-link-hover {\n    background: #96a2a8\n}\n\n.w-socials.color_brand .w-socials-item.facebook .w-socials-item-link {\n    color: #1e77f0\n}\n\n.w-socials-item.facebook .w-socials-item-link-hover {\n    background: #1e77f0\n}\n\n.w-socials.color_brand .w-socials-item.flickr .w-socials-item-link {\n    color: #ff0084\n}\n\n.w-socials-item.flickr .w-socials-item-link-hover {\n    background: #ff0084\n}\n\n.w-socials.color_brand .w-socials-item.foursquare .w-socials-item-link {\n    color: #fa4b7a\n}\n\n.w-socials-item.foursquare .w-socials-item-link-hover {\n    background: #fa4b7a\n}\n\n.w-socials.color_brand .w-socials-item.github .w-socials-item-link {\n    color: inherit\n}\n\n.w-socials-item.github .w-socials-item-link-hover {\n    background: #24292e\n}\n\n.w-socials.color_brand .w-socials-item.google .w-socials-item-link {\n    color: #ff3e30\n}\n\n.w-socials-item.google .w-socials-item-link-hover {\n    background: #ff3e30\n}\n\n.w-socials.color_brand .w-socials-item.houzz .w-socials-item-link {\n    color: #4dbc15\n}\n\n.w-socials-item.houzz .w-socials-item-link-hover {\n    background: #4dbc15\n}\n\n.w-socials.color_brand .w-socials-item.imdb .w-socials-item-link {\n    color: #f7c625\n}\n\n.w-socials-item.imdb .w-socials-item-link-hover {\n    background: #f7c625\n}\n\n.w-socials.color_brand .w-socials-item.instagram .w-socials-item-link {\n    color: inherit\n}\n\n.w-socials-item.instagram .w-socials-item-link-hover {\n    background: #a17357;\n    background: radial-gradient(circle farthest-corner at 35% 100%,#fec564,transparent 50%),radial-gradient(circle farthest-corner at 10% 140%,#feda7e,transparent 50%),radial-gradient(ellipse farthest-corner at 0 -25%,#5258cf,transparent 50%),radial-gradient(ellipse farthest-corner at 20% -50%,#5258cf,transparent 50%),radial-gradient(ellipse farthest-corner at 100% 0,#893dc2,transparent 50%),radial-gradient(ellipse farthest-corner at 60% -20%,#893dc2,transparent 50%),radial-gradient(ellipse farthest-corner at 100% 100%,#d9317a,transparent),linear-gradient(#6559ca,#bc318f 30%,#e42e66 50%,#fa5332 70%,#ffdc80 100%)\n}\n\n.w-socials-item.instagram .w-socials-item-link i {\n    font-size: 1.1em\n}\n\n.w-socials.color_brand .w-socials-item.linkedin .w-socials-item-link {\n    color: #0077b5\n}\n\n.w-socials-item.linkedin .w-socials-item-link-hover {\n    background: #0077b5\n}\n\n.w-socials.color_brand .w-socials-item.medium .w-socials-item-link {\n    color: inherit\n}\n\n.w-socials-item.medium .w-socials-item-link-hover {\n    background: #1c1b1a\n}\n\n.w-socials.color_brand .w-socials-item.odnoklassniki .w-socials-item-link {\n    color: #f58220\n}\n\n.w-socials-item.odnoklassniki .w-socials-item-link-hover {\n    background: #f58220\n}\n\n.w-socials.color_brand .w-socials-item.pinterest .w-socials-item-link {\n    color: #e60023\n}\n\n.w-socials-item.pinterest .w-socials-item-link-hover {\n    background: #e60023\n}\n\n.w-socials.color_brand .w-socials-item.reddit .w-socials-item-link {\n    color: #ff4500\n}\n\n.w-socials-item.reddit .w-socials-item-link-hover {\n    background: #ff4500\n}\n\n.w-socials.color_brand .w-socials-item.rss .w-socials-item-link {\n    color: #ff9702\n}\n\n.w-socials-item.rss .w-socials-item-link-hover {\n    background: #ff9702\n}\n\n.w-socials.color_brand .w-socials-item.skype .w-socials-item-link {\n    color: #00aff0\n}\n\n.w-socials-item.skype .w-socials-item-link-hover {\n    background: #00aff0\n}\n\n.w-socials.color_brand .w-socials-item.soundcloud .w-socials-item-link {\n    color: #ff5600\n}\n\n.w-socials-item.soundcloud .w-socials-item-link-hover {\n    background: #ff5600\n}\n\n.w-socials.color_brand .w-socials-item.telegram .w-socials-item-link {\n    color: #0e8ed4\n}\n\n.w-socials-item.telegram .w-socials-item-link-hover {\n    background: #0e8ed4\n}\n\n.w-socials.color_brand .tiktok .w-socials-item-link {\n    color: inherit;\n    text-shadow: .04em .04em 0 #ee1d52,-.04em -.04em 0 #69c9d0\n}\n\n.w-socials .tiktok .w-socials-item-link-hover {\n    background: #000\n}\n\n.w-socials.color_brand .tripadvisor .w-socials-item-link {\n    color: inherit\n}\n\n.w-socials.style_colored .tripadvisor .w-socials-item-link,.no-touch .w-socials:not(.shape_none):not(.hover_none) .tripadvisor .w-socials-item-link:hover {\n    color: #000a12!important\n}\n\n.w-socials .tripadvisor .w-socials-item-link-hover {\n    background: #34e0a1\n}\n\n.w-socials.color_brand .w-socials-item.tumblr .w-socials-item-link {\n    color: #37465d\n}\n\n.w-socials-item.tumblr .w-socials-item-link-hover {\n    background: #37465d\n}\n\n.w-socials.color_brand .w-socials-item.twitch .w-socials-item-link {\n    color: #6441a5\n}\n\n.w-socials-item.twitch .w-socials-item-link-hover {\n    background: #6441a5\n}\n\n.w-socials.color_brand .w-socials-item.twitter .w-socials-item-link {\n    color: #55acee\n}\n\n.w-socials-item.twitter .w-socials-item-link-hover {\n    background: #55acee\n}\n\n.w-socials.color_brand .w-socials-item.vimeo .w-socials-item-link {\n    color: #1ab7ea\n}\n\n.w-socials-item.vimeo .w-socials-item-link-hover {\n    background: #1ab7ea\n}\n\n.w-socials.color_brand .w-socials-item.vk .w-socials-item-link {\n    color: #2787F5\n}\n\n.w-socials-item.vk .w-socials-item-link-hover {\n    background: #2787F5\n}\n\n.w-socials.color_brand .w-socials-item.wechat .w-socials-item-link {\n    color: #60c33a\n}\n\n.w-socials-item.wechat .w-socials-item-link-hover {\n    background: #60c33a\n}\n\n.w-socials.color_brand .w-socials-item.whatsapp .w-socials-item-link {\n    color: #25d366\n}\n\n.w-socials-item.whatsapp .w-socials-item-link-hover {\n    background: #25d366\n}\n\n.w-socials.color_brand .w-socials-item.xing .w-socials-item-link {\n    color: #006464\n}\n\n.w-socials-item.xing .w-socials-item-link-hover {\n    background: #006464\n}\n\n.w-socials.color_brand .w-socials-item.yelp .w-socials-item-link {\n    color: #d32323\n}\n\n.w-socials-item.yelp .w-socials-item-link-hover {\n    background: #d32323\n}\n\n.w-socials.color_brand .w-socials-item.youtube .w-socials-item-link {\n    color: #f00\n}\n\n.w-socials-item.youtube .w-socials-item-link-hover {\n    background: #f00\n}\n\n.color_alternate .w-socials.style_solid .w-socials-item-link {\n    background: var(--color-alt-content-bg-alt-grad)\n}\n\n.color_alternate .w-socials.style_outlined .w-socials-item-link {\n    box-shadow: inset 0 0 0 2px var(--color-alt-content-border)\n}\n\n.color_footer-top .w-socials.style_solid .w-socials-item-link {\n    background: var(--color-subfooter-bg-alt-grad)\n}\n\n.color_footer-top .w-socials.style_outlined .w-socials-item-link {\n    box-shadow: inset 0 0 0 2px var(--color-subfooter-border)\n}\n\n.color_footer-bottom .w-socials.style_solid .w-socials-item-link {\n    background: var(--color-footer-bg-alt-grad)\n}\n\n.color_footer-bottom .w-socials.style_outlined .w-socials-item-link {\n    box-shadow: inset 0 0 0 2px var(--color-footer-border)\n}\n\n.rounded_none .w-socials-item-popup {\n    border-radius: 0!important\n}\n\n\n\n\n// .ripple-container {\n//     position: absolute!important;\n//     top: 0;\n//     right: 0;\n//     bottom: 0;\n//     left: 0;\n//     z-index: 0!important;\n//     display: block;\n//     overflow: hidden;\n//     padding: 0!important;\n//     border-radius: inherit;\n//     pointer-events: none\n// }\n\n// .ripple {\n//     position: absolute;\n//     display: block;\n//     margin-top: -10px;\n//     margin-left: -10px;\n//     width: 20px;\n//     height: 20px;\n//     border-radius: 100%;\n//     background-color: currentColor;\n//     opacity: 0;\n//     transform: scale(1);\n//     pointer-events: none\n// }\n\n// .ripple.ripple-on {\n//     opacity: 0.1;\n//     transition: transform 0.4s cubic-bezier(.4,0,.2,1);\n// }\n\n// .ripple.ripple-out {\n//     opacity: 0!important;\n//     transition: opacity 0.2s linear!important;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
